export default __webpack_public_path__ + "static/media/share-icon-large.53c65735.svg";